module.exports = __webpack_public_path__ + "img/ford-explorer-2025.19e68646.png";